// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-offers-more-background {
  background: radial-gradient(blue, var(--brand-blue2))
}

#context-offers-more {
  backdrop-filter: blur(1px);
}

#context-offers-more h2 {
  color: var(--brand-white1);
  text-shadow: var(--text-shadow1);
  letter-spacing: 1px;
}

.context-offers-more-gp {
  padding: 0 8px;
}

.context-offers-more-item {
  background-color: white;
  border: 1px solid black;
  border-radius: 10px;
  border-top: 1px solid var(--brand-white3);
  border-left: 1px solid var(--brand-white3);
  box-shadow: 3px 3px 3px var(--brand-white3);
  padding: 10px;
  min-width: 250px;
  width: 100%;
  max-width: 400px;

  z-index: 0;
}

.context-offers-more-item h3 {
  text-align: center;
  margin: 0;
  font-size: 150%;
  font-family: var(--font-family1);
}

.context-offers-more-item p {
  text-indent: 2rem;
}

.context-offers-more-item .svg-ct {
  position: relative;
  height: 100%;
}

.context-offers-more-item .svg-ct svg {
  height: 80%;
  width: 100%;
  padding-top: 30px;
  position: absolute;
  opacity: .2;
  fill: var(--brand-blue1);
  stroke: var(--brand-red1);
  stroke-width: 4;
  stroke-dasharray: 1 6;
  stroke-linecap: round;
  z-index: -1;
}



/* Add a background image for larger screens */
@media (min-width: 1040px) {
  .context-offers-more-background {
    background-image: url("https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/background-minified-js-600w.webp");
    background-size: cover;
  }
  #context-offers-more h2 {
    background-color: black;
    border: 1px var(--brand-red1) dotted;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/card-groups/ContextOffersMoreCardGroup/ContextOffersMoreCardGroup.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;;EAEhB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;;;AAIA,8CAA8C;AAC9C;EACE;IACE,iJAAiJ;IACjJ,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,oCAAoC;EACtC;AACF","sourcesContent":[".context-offers-more-background {\n  background: radial-gradient(blue, var(--brand-blue2))\n}\n\n#context-offers-more {\n  backdrop-filter: blur(1px);\n}\n\n#context-offers-more h2 {\n  color: var(--brand-white1);\n  text-shadow: var(--text-shadow1);\n  letter-spacing: 1px;\n}\n\n.context-offers-more-gp {\n  padding: 0 8px;\n}\n\n.context-offers-more-item {\n  background-color: white;\n  border: 1px solid black;\n  border-radius: 10px;\n  border-top: 1px solid var(--brand-white3);\n  border-left: 1px solid var(--brand-white3);\n  box-shadow: 3px 3px 3px var(--brand-white3);\n  padding: 10px;\n  min-width: 250px;\n  width: 100%;\n  max-width: 400px;\n\n  z-index: 0;\n}\n\n.context-offers-more-item h3 {\n  text-align: center;\n  margin: 0;\n  font-size: 150%;\n  font-family: var(--font-family1);\n}\n\n.context-offers-more-item p {\n  text-indent: 2rem;\n}\n\n.context-offers-more-item .svg-ct {\n  position: relative;\n  height: 100%;\n}\n\n.context-offers-more-item .svg-ct svg {\n  height: 80%;\n  width: 100%;\n  padding-top: 30px;\n  position: absolute;\n  opacity: .2;\n  fill: var(--brand-blue1);\n  stroke: var(--brand-red1);\n  stroke-width: 4;\n  stroke-dasharray: 1 6;\n  stroke-linecap: round;\n  z-index: -1;\n}\n\n\n\n/* Add a background image for larger screens */\n@media (min-width: 1040px) {\n  .context-offers-more-background {\n    background-image: url(\"https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/background-minified-js-600w.webp\");\n    background-size: cover;\n  }\n  #context-offers-more h2 {\n    background-color: black;\n    border: 1px var(--brand-red1) dotted;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
